export default function Reducer(state, action) {
  switch (action.type) {
    case 'LOAD':
      return {
        ...state,
        notes: action.notes,
      };

    case 'CREATE':
      return {
        ...state,
        notes: [...state.notes, action.note],
      };

    case 'UPDATE':
      return {
        ...state,
        notes: state.notes.map(
          (note) => (note.id === action.note.id ? action.note : note),
        ),
      };

    case 'DESTROY':
      return {
        ...state,
        notes: state.notes.filter(
          (note) => note.id !== action.noteId,
        ),
      };

    default:
      throw Error(`Unknown action: ${action.type}`);
  }
}
